import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Layers, TrendingDown, ShieldCheck } from "lucide-react";
import OverlapTool from "./tools/OverlapTool";
import UnderperformanceTool from "./tools/UnderperformanceTool";
import InsuranceAnalyzer from "./tools/InsuranceAnalyzer";

/**
 * Top-level Tools page. When invoked standalone, no client context. When
 * embedded inside a Client Workspace, pass clientId to pre-load held funds.
 */
export default function ToolsPage({ clientId, defaultTool = "overlap" }) {
  const [tool, setTool] = useState(defaultTool);
  return (
    <div className="space-y-6">
      {!clientId && (
        <div>
          <p className="overline text-primary">Portfolio analysis</p>
          <h1 className="font-dashboard text-3xl font-bold tracking-tight">Tools</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Ad-hoc utilities used while building recommendations. Pick funds from your research DB, a client&apos;s holdings, or enter them manually.
          </p>
        </div>
      )}

      <Tabs value={tool} onValueChange={setTool}>
        <TabsList>
          <TabsTrigger value="overlap" data-testid="tools-tab-overlap"><Layers className="mr-2 h-3 w-3" /> Overlap</TabsTrigger>
          <TabsTrigger value="underperformance" data-testid="tools-tab-underperformance"><TrendingDown className="mr-2 h-3 w-3" /> Underperformance</TabsTrigger>
          <TabsTrigger value="policy-analyzer" data-testid="tools-tab-policy-analyzer"><ShieldCheck className="mr-2 h-3 w-3" /> Policy Analyzer</TabsTrigger>
        </TabsList>
        <div className="mt-6">
          <TabsContent value="overlap"><OverlapTool clientId={clientId} /></TabsContent>
          <TabsContent value="underperformance"><UnderperformanceTool clientId={clientId} /></TabsContent>
          <TabsContent value="policy-analyzer"><InsuranceAnalyzer clientId={clientId} /></TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
